import { SyncStreamConnectionMethod, type SyncOptions } from "@powersync/common"

export type PowerSyncConnectionDriver = "native" | "web"

/**
 * Resolve the rollout transport deliberately. HTTP streaming is the v2
 * default. WebSocket remains available for comparison and rollback on the web
 * driver, while the native Capacitor driver stays on its recommended HTTP
 * path.
 */
export function resolvePowerSyncConnectionMethod(
  configured: string | undefined,
  driver: PowerSyncConnectionDriver,
): SyncStreamConnectionMethod {
  const value = configured?.trim()

  if (driver === "native") {
    return SyncStreamConnectionMethod.HTTP
  }

  if (!value || value === SyncStreamConnectionMethod.HTTP) {
    return SyncStreamConnectionMethod.HTTP
  }
  if (value === SyncStreamConnectionMethod.WEB_SOCKET) {
    return SyncStreamConnectionMethod.WEB_SOCKET
  }

  throw new Error(
    `Invalid VITE_POWERSYNC_CONNECTION_METHOD: ${value}. Expected "http" or "web-socket".`,
  )
}

export const powerSyncConnectionMethod = resolvePowerSyncConnectionMethod(
  import.meta.env.VITE_POWERSYNC_CONNECTION_METHOD,
  __POWERSYNC_DRIVER__,
)

export const powerSyncConnectionOptions: SyncOptions = {
  connectionMethod: powerSyncConnectionMethod,
}
